module.exports = __webpack_public_path__ + "a83365a5ea99cd06a6a6ad3b3b156fe4.jpg";